<template>
  <div class="rm-screen">
    <div v-if="isRange" class="rm-empty">
      <v-icon size="40" color="#8a817a">mdi-calendar-today</v-icon>
      {{ $t("daily_report") }}
    </div>
    <div v-else-if="!selectedCompany" class="rm-empty">
      <v-icon size="40" color="#8a817a">mdi-domain</v-icon>
      {{ $t("report_mobile.employees_pick_company") }}
    </div>
    <div v-else-if="loading" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>

    <template v-else>
      <group-mobile-shift-chips v-model="selectedShift" :shifts="shifts"></group-mobile-shift-chips>

      <div v-if="!slips.length" class="rm-empty">
        <template v-if="filters.search">{{ $t("report_mobile.no_results_for", { search: filters.search }) }}</template>
        <template v-else>
          <v-icon size="40" color="#8a817a">mdi-food-off</v-icon>
          {{ $t("no_orders_found") }}
        </template>
      </div>

      <template v-else>
        <div class="rm-stats rm-stats--pair">
          <div class="rm-stat rm-stat--inverse">
            <span class="rm-stat__label">{{ $t("report_desktop.workers") }}</span>
            <span class="rm-stat__value rm-num">{{ slips.length }}</span>
          </div>
          <div class="rm-stat">
            <span class="rm-stat__label">{{ $t("report_desktop.total_meals") }}</span>
            <span class="rm-stat__value rm-num">{{ mealTotal }}</span>
          </div>
        </div>
        <group-mobile-slip-list
          :slips="listSlips"
          :shift="Number(selectedShift)"
          :layout="0"
        ></group-mobile-slip-list>
      </template>
    </template>
  </div>
</template>

<script>
import ReportTabGroupMealsTabOrders from "@/components/report/group-meals/ReportTabGroupMealsTabOrders.vue";
import hasGroupSlips from "../../../shared/group/hasGroupSlips";
import GroupMobileShiftChips from "./GroupMobileShiftChips.vue";
import GroupMobileSlipList from "./GroupMobileSlipList.vue";

/**
 * Mobilni "Naručeno" (jela iz grupa): jedna firma i jedna smena (oznake smena na vrhu), radnici sa obrocima po
 * grupama jela. Radi samo za jedan dan. Firma i period su u zaglavlju, pretraga u lupi. Nasleđuje učitavanje,
 * štampu i Excel iz starog taba.
 */
export default {
  name: "GroupMobileOrdered",
  extends: ReportTabGroupMealsTabOrders,
  mixins: [hasGroupSlips],
  components: { GroupMobileShiftChips, GroupMobileSlipList },
  computed: {
    listSlips() {
      return this.slips.map((slip) => ({ ...slip, no: slip.id }));
    },
  },
};
</script>
